"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackAdditionalPromoClick = trackAdditionalPromoClick;
var _analytics = require("@cian/analytics");
function trackAdditionalPromoClick(_ref) {
  let {
    type,
    id
  } = _ref;
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_block',
    label: type || 'linked_promo',
    products: [{
      extra: {
        promoid: id,
        place_type: 'different_price'
      }
    }]
  });
}